var en_us = {
    values: {
        'Registrar atividade': 'Register activity',
        'Editar registro de atividade': 'Edit activity log',
        Registros: 'Logs',
        Qualifier: 'Qualifier',
        'Default Mnemonic': 'Default Mnemonic',
        'Default Unit': 'Default Unit',
        'must not be empty': 'must not be empty',
        Apply: 'Apply',
        Add: 'Add',
        'add line': 'Add line',
        copy: 'copy',
        'Well name': 'Well name',
        'Include extra fields': 'Include extra fields',
        'Begin date': 'Begin date',
        'End date': 'End date',
        'The end time must be selected when choosing an end date':
            'The end time must be selected when choosing an end time',
        optional: 'optional',
        Hour: 'Hour',
        Intervention: 'Intervention',
        Choose: 'Choose',
        'Detailing 1': 'Detailing 1',
        'Detailing 2': 'Detailing 2',
        Classification: 'Classification',
        'Additional information': 'Additional information',
        Save: 'Save',
        Cancel: 'Cancel',
        'Client Role': 'Client Role',
        'Basic information': 'Basic information',
        'Service Nature': 'Service Nature',
        'Value generation estimate': 'Value generation estimate',
        'Safety/Conformity': 'Safety/Conformity',
        'Performance/Financial': 'Performance/Financial',
        'Tags (opcional, crie com vírgula ou [enter])': 'Tags (optional, create with comma or [enter])',
        'Posto CSD': 'CSD station',
        Comments: 'Comments',
        'Leak-off test': 'LOT',
        'Pore pressure': 'PP',
        'Riser safety margin': 'MSR',
        Activity: 'Process',
        'undefined error': 'undefined error',
        'Activity Log': 'Activity Log',
        'Create Operation Comments': 'Create Operation Comments',
        'Create Activity Log': 'Create Activity Log',
        'csdContacts': 'CSD Contacts',
        'csd': 'CSD',
        'Performance Gain': 'Performance Gain',
        'SMS Gain': 'SMS Gain'
    }
}

module.exports = en_us
